import React, { FC, useEffect, useState } from 'react';
import Modal from '@common/modal';

import classnames from 'classnames/bind';
import styles from './applyConfirm.module.scss';
const cx = classnames.bind(styles);

interface IApplyConfirmModalProps {
  visible: boolean;
  title?: string;
  onClose: () => void;
  onConfirm: () => void;
}

const ApplyConfirmModal: FC<IApplyConfirmModalProps> = ({
  visible,
  onConfirm,
  onClose,
  title = '역량검사 응시하기',
}) => {
  const [isDisabledApplyBtn, setIsDisabledApplyBtn] = useState(false);

  const onApply = () => {
    setIsDisabledApplyBtn(true);
    onConfirm();
  };

  useEffect(() => {
    if (visible) {
      setIsDisabledApplyBtn(false);
    }
  }, [visible]);

  return (
    <Modal visible={visible} dimmed={true}>
      <div className={cx('layer')}>
        <strong className={cx('title')}>{title}</strong>
        <p className={cx('desc')}>
          응시 중이던 기회 1회는 사라지게 됩니다.
          <br />
          처음부터 응시하시겠습니까?
        </p>

        <div className={cx('btnArea')}>
          <a className={cx('btn', 'cancel')} role="button" onClick={onClose}>
            아니오
          </a>
          <button className={cx('btn', 'confirm')} onClick={onApply} disabled={isDisabledApplyBtn}>
            응시하기
          </button>
        </div>

        <a className={cx('btnClose')} onClick={onClose} role="button">
          <span className={cx('hidden')}>close</span>
        </a>
      </div>
    </Modal>
  );
};

export default ApplyConfirmModal;
